import { useEffect } from "react"

import { Divider, Form, Typography } from "antd"
import { useForm } from "antd/es/form/Form"

import { sourceDetailComponentMap } from "./SourceDetail/SourceDetail"
import SourceSelect from "./SourceSelect/SourceSelect"

const { Text } = Typography

const sourceDetailLabelsMap = {
  social_media: "Which social media platform did you find us from?",
  ai_tools: "Which AI tool did you find us from?",
  partner_program: "Which course or community? *",
  events: "Which event or award? *",
  industry_recommendation: (
    <Text>
      Who recommended us?<Text type="secondary"> (optional)</Text>
    </Text>
  ),
  other: "What source helped you to find us? *"
}

const sourcesWithRequiredDetails = ["social_media", "partner_program", "events", "other"]

const formatSourceDetailForSubmitMap = {
  social_media: (value) => ({
    follow_up_value: value?.type ?? value ?? null,
    custom_response: value?.type === "Other" ? (value?.value?.trim() ?? null) : null
  }),
  ai_tools: (value) => ({
    follow_up_value: value?.type ?? value ?? null,
    custom_response: value?.type === "Other" ? (value?.value?.trim() ?? null) : null
  }),
  partner_program: (value) => ({
    custom_response: value?.trim() ?? null
  }),
  events: (value) => ({
    custom_response: value?.trim() ?? null
  }),
  industry_recommendation: (value) => ({
    custom_response: value?.trim() ?? null
  }),
  other: (value) => ({
    custom_response: value?.trim() ?? null
  })
}

const HowDidYouFindUsForm = ({ setIsValidForm, onSubmit }) => {
  const [form] = useForm()
  const source = Form.useWatch("source", form)

  const values = Form.useWatch([], form)

  const manuallyValidateForm = (values) => {
    if (!values?.source) return false
    const isDetailRequired = sourcesWithRequiredDetails.includes(values?.source)
    if (!values?.sourceDetail && isDetailRequired) {
      return false
    }
    if (typeof values?.sourceDetail === "string") {
      if (!values?.sourceDetail?.trim() && isDetailRequired) return false
    }
    if (values?.sourceDetail?.type === "Other" && typeof values?.sourceDetail?.value === "string") {
      if (!values?.sourceDetail?.value?.trim() && isDetailRequired) return false
    }
    return true
  }

  useEffect(() => {
    setIsValidForm(manuallyValidateForm(values))
  }, [values])

  useEffect(() => {
    form.setFieldValue("sourceDetail", null)
  }, [source, form])

  const submitForm = (data) => {
    onSubmit({
      category: data.source,
      ...formatSourceDetailForSubmitMap?.[data.source]?.(data.sourceDetail)
    })
  }

  return (
    <Form form={form} layout="vertical" name="how-did-you-find-us-form" onFinish={submitForm}>
      <Form.Item name="source">
        <SourceSelect />
      </Form.Item>
      {sourceDetailComponentMap?.[source] && <Divider style={{ margin: "0 0 16px 0" }} />}
      {sourceDetailComponentMap?.[source] && (
        <Form.Item name="sourceDetail" label={sourceDetailLabelsMap[source]} required={false}>
          {sourceDetailComponentMap[source]}
        </Form.Item>
      )}
    </Form>
  )
}

export default HowDidYouFindUsForm
